import React, { useState } from "react";
import { Alert, Button, Form, InputGroup, Spinner } from "react-bootstrap";

const CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";

function generatePassword() {
  return Array.from(
    { length: 8 },
    () => CHARS[Math.floor(Math.random() * CHARS.length)]
  ).join("");
}

export default function PasswordReset({ info, onSave, onGenerate, saving }) {
  const [password, setPassword] = useState("");
  const [copyStatus, setCopyStatus] = useState("idle"); // idle | copied | error

  const handleGenerate = () => {
    const pwd = generatePassword();
    setPassword(pwd);
    setCopyStatus("idle");
    onGenerate?.(pwd);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopyStatus("copied");
      setTimeout(() => setCopyStatus("idle"), 2000);
    } catch {
      setCopyStatus("error");
    }
  };

  const copyLabel = {
    idle: "Copiar",
    copied: "¡Copiado!",
    error: "Error al copiar",
  }[copyStatus];

  const copyVariant = {
    idle: "outline-secondary",
    copied: "success",
    error: "danger",
  }[copyStatus];

  return (
    <div>
      <p className="mb-1 text-muted small">Usuario</p>
      <p className="fw-semibold mb-4">{info?.nombre_completo}</p>

      <Button
        variant="outline-primary"
        className="w-100 mb-3"
        onClick={handleGenerate}
        disabled={saving}
      >
        Generar contraseña
      </Button>

      {password && (
        <>
          <Form.Label className="text-muted small">
            Contraseña generada
          </Form.Label>
          <InputGroup className="mb-4">
            <Form.Control
              type="text"
              value={password}
              readOnly
              className="font-monospace fs-5 text-center letter-spacing-wide"
              aria-label="Contraseña generada"
            />
            <Button
              variant={copyVariant}
              onClick={handleCopy}
              style={{ minWidth: "90px" }}
            >
              {copyLabel}
            </Button>
          </InputGroup>

          {copyStatus === "error" && (
            <Alert variant="warning" className="py-2 small mb-3">
              No se pudo copiar automáticamente. Copia la contraseña
              manualmente.
            </Alert>
          )}

          <Button
            variant="primary"
            className="w-100"
            onClick={() => onSave(info.id, password)}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Guardando…
              </>
            ) : (
              "Guardar contraseña"
            )}
          </Button>
        </>
      )}
    </div>
  );
}
